import React, { useState } from 'react';
import ServerImage from './ServerImage';
import { SlSocialLinkedin } from "react-icons/sl";


const AboutFounder = () => {
  const [showDescription, setShowDescription] = useState(false);

  const founderData = {
    name: 'Nour El Houda Zraibia',
    title: 'Founder and CEO',
    traits: ['Precise', 'Strategic', 'Relentless', 'Human'],
    image: '/team/nour.png',
    description: {
      role: 'Engineer, Data Scientist, International Consultant & Trainer, Athlete.',
      philosophy: `Founder who sees clients as journeys. My team is my family. Your project is my challenge. We believe in one principle that will never change: your project and your feelings matter as much as the final product. More than a business, this is accomplishment — the art of guiding you smoothly through every single step, with patience, clarity, and genuine care. My clients don't just stay. They love us. Because we make them feel important. Seen. Understood. And that doesn't happen by accident.`,
      teamCulture: `I trained my team to be the same way. Not as employees, but as family. We are We Tekup. A unit. A heartbeat. I take care of them like they belong to my dream, because they do. This company isn't just what I do. It's who I am.`,
      expertise: `I am an engineer, a data scientist and a robotic trainer. I notice anomalies before they become problems. I am fast. I am sharp. I love challenges the kind that make others say "impossible."`,
      promise: `And outside work? I am an athlete. I train hard. Regularly. Discipline in the body feeds discipline in the mind. My ambition is to do what no one has done before. To create things that don't just work but rewrite the rules. So here's my promise to you: You bring your project. Bring your ideas, your vision, your ambition. I bring patience, brilliance, speed, and a family that will carry you to the finish line. Let's build something unforgettable. Together. Let's do what no one has done before.`
    }
  };

  return (
    <section className="py-4 md:py-2 px-4 max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-0">
        <h2 className="text-2xl lg:text-4xl font-bold  mb-0 md:mb-12">About the founder</h2>
        
        <div className="flex flex-col lg:flex-row gap-4 md:gap-20 items-start">
          {/* Left - Image Card */}
          <div className="flex justify-center w-full md:w-1/3 lg:justify-start">
            <div className="relative">
              {/* Blue Background Rectangle */}
              <div 
                className="w-full md:w-[380px] h-[370px] md:h-[450px] rounded-3xl absolute top-10 md:left-2 z-0"
                style={{ 
                  backgroundColor: 'var(--primary-blue)',
                  borderRadius: '28px'
                }}
              ></div>
              
              {/* Photo positioned in front of blue background */}
              <ServerImage 
                src={founderData.image} 
                alt={founderData.name}
                fallback="/team/nour.png"
                className="w-full h-[410px] md:h-[490px] object-cover object-center rounded-3xl relative z-10"
                style={{ borderRadius: '28px' }}
              />
            </div>
          </div>

          {/* Right - Content */}
          <div className="w-full md:w-2/3">
            {/* Name and Title */}
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">{founderData.name}</h3>
              
              {/* Traits */}
              <div className="flex flex-wrap items-center gap-1 md:gap-3 mb-6">
                <div className="flex items-center gap-2 bg-gray-100 px-3 py-1 rounded-full">
                  <div className="w-3 h-3 bg-primary-blue rounded-full"></div>
                  <span className="text-gray-600 text-sm">Founder and CEO</span>
                </div>
                
                <div className="bg-gray-100 px-3 py-1 rounded-full">
                  <span className="text-gray-600 text-sm">Precise</span>
                </div>
                
                <div className="bg-gray-100 px-3 py-1 rounded-full">
                  <span className="text-gray-600 text-sm">Strategic</span>
                </div>
                
                <div className="bg-gray-100 px-3 py-1 rounded-full">
                  <span className="text-gray-600 text-sm">Relentless</span>
                </div>
                
                <div className="bg-gray-100 px-3 py-1 rounded-full">
                  <span className="text-gray-600 text-sm">Human</span>
                </div>
                
                <button 
                  onClick={() => window.open('https://linkedin.com/in/nour-zraibia', '_blank')}
                  className="w-8 h-8 bg-gray-100 rounded-full flex items-center text-primary-blue hover:text-white  justify-center hover:bg-blue-700 transition-colors duration-200"
                >
                  <SlSocialLinkedin />
                </button>
              </div>
            </div>

            {/* Description */}
            <div className="text-base font-light">
              {/* Mobile: Show button to toggle description */}
              <div className="md:hidden">
                {!showDescription ? (
                  <>
                    <p className="font-light">
                      Founder who sees clients as journeys. My team is family. Your project is my challenge. We believe in one principle that will never change <span>...</span>
                    </p>
                    
                    <button
                      onClick={() => setShowDescription(true)}
                      className="w-1/2 py-3 px-6 mx-auto bg-gray-100 hover:bg-gray-200 rounded-full text-gray-700 font-medium transition-colors duration-200 flex items-center justify-center gap-2"
                    >
                      Read more...
                    </button>
                  </>
                ) : (
                  <div className="space-y-4">
                    <p>
                      Founder who sees clients as journeys. My team is my family. Your project is my challenge. We believe in one principle that will never change: your project and your feelings matter as much as the final product. More than a business, this is accomplishment — the art of guiding you smoothly through every single step, with patience, clarity, and genuine care. My clients don't just stay. They love us. Because we make them feel important. Seen. Understood. And that doesn't happen by accident.
                    </p>
                    
                    <p>
                      I trained my team to be the same way. Not as employees, but as family. We are We Tekup. A unit. A heartbeat. I take care of them like they belong to my dream, because they do. This company isn't just what I do. It's who I am.
                    </p>
                    
                    <p>
                      I am an engineer, a data scientist and a robotic trainer. I notice anomalies before they become problems. I am fast. I am sharp. I love challenges the kind that make others say "impossible."
                    </p>
                    
                    <p>
                      And outside work? I am an athlete. I train hard. Regularly. Discipline in the body feeds discipline in the mind. My ambition is to do what no one has done before. To create things that don't just work but rewrite the rules. So here's my promise to you: You bring your project. Bring your ideas, your vision, your ambition. I bring patience, brilliance, speed, and a family that will carry you to the finish line. Let's build something unforgettable. Together. Let's do what no one has done before.
                    </p>
                    
                    <button
                      onClick={() => setShowDescription(false)}
                      className="w-full py-3 px-6 bg-gray-100 hover:bg-gray-200 rounded-full text-gray-700 font-medium transition-colors duration-200 flex items-center justify-center gap-2 mt-4"
                    >
                      Show less
                    </button>
                  </div>
                )}
              </div>

              {/* Desktop: Always show full description */}
              <div className="hidden md:block space-y-4">
                <p className="font-medium">
                  Engineer, Data Scientist, International Consultant & Trainer, Athlete.
                </p>
                
                <p>
                  Founder who sees clients as journeys. My team is my family. Your project is my challenge. We believe in one principle that will never change: your project and your feelings matter as much as the final product. More than a business, this is accomplishment — the art of guiding you smoothly through every single step, with patience, clarity, and genuine care. My clients don't just stay. They love us. Because we make them feel important. Seen. Understood. And that doesn't happen by accident.
                </p>
                
                <p>
                  I trained my team to be the same way. Not as employees, but as family. We are We Tekup. A unit. A heartbeat. I take care of them like they belong to my dream, because they do. This company isn't just what I do. It's who I am.
                </p>
                
                <p>
                  I am an engineer, a data scientist and a robotic trainer. I notice anomalies before they become problems. I am fast. I am sharp. I love challenges the kind that make others say "impossible."
                </p>
                
                <p>
                  And outside work? I am an athlete. I train hard. Regularly. Discipline in the body feeds discipline in the mind. My ambition is to do what no one has done before. To create things that don't just work but rewrite the rules. So here's my promise to you: You bring your project. Bring your ideas, your vision, your ambition. I bring patience, brilliance, speed, and a family that will carry you to the finish line. Let's build something unforgettable. Together. Let's do what no one has done before.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutFounder;